module.exports = __webpack_public_path__ + "static/img/4.784b2d87.png";